import { render } from "./Mp3.vue?vue&type=template&id=3752ba5a"
import script from "./Mp3.vue?vue&type=script&lang=js"
export * from "./Mp3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__